import React, {Component} from 'react';
import {
  Row,
  Col,
  Tabs,
  Tab as TabB,
  Checkbox
}                         from 'react-bootstrap';

import TabItem            from './TabItem';

class Tab extends Component {

  render() {
    let {
      checkboxes,
      isLoading,
      toggleCheckbox
    } = this.props;

    const isUndefined = (obj) => typeof obj === 'undefined'
      ? true
      : false;

    const getTabs = (mod, index) => {
      return (
        <TabB
          key={mod.module+index}
          eventKey={index+1}
          title={mod.module}
          >
          <TabItem data={mod} toggleCheckbox={toggleCheckbox} />
        </TabB>
      );
    };
    return (
      <Row>
        {
          isLoading ?
          <Col md={12} style={{ textAlign: 'center' }}>
            <i className="fa fa-spinner fa-3x fa-spin"></i>
          </Col>
          :
          <Col md={12} >
            <Tabs defaultActiveKey={1} id="access-tab">
              {
                isUndefined(checkboxes)
                ? <div>NO DATA</div>
                : checkboxes.map(getTabs)
              }
            </Tabs>
          </Col>
        }
      </Row>
    );
  }
}

export default Tab;



// WEBPACK FOOTER //
// ./components/AccessRight/Tab.js